export const metadata = {
  title: "Venue Spotlight: Antarès Le Mans 🔍",
  date: "2025-05-02",
  excerpt: "We shine the spotlight on the venue chosen by hosts Etoile lavalloise",
  slug: "venue-spotlight-antarès-le-mans",
  content: `
    The business end of the futsal season is approaching and the games are coming thick and fast.

    Today we take a closer look at the venue chosen to host the final four of the 2025 UEFA Mens Champions League Futsal finals. Antarès Sports Arena in Le Mans.

    For those interested in the upcoming champions league finals it will be shown as follows:

    Finals schedule:

    Friday 2 May (Semi-finals):
    - Kairat Almaty vs Cartagena Costa Cálida (18:00)
    - Sporting CP vs Illes Balears Palma (21:00)

    Sunday 4 May:
    - Third-place play-off (17:00)
    - Final (20:00)

    (All times CET)

    Also UEFA has provided a link so that you can watch the games in your respective countries:
    https://www.uefa.com/uefafutsalchampionsleague/news/0298-1da4be8431cf-0ac3b682f0c2-1000--where-to-watch-the-uefa-futsal-champions-league-finals/

    Returning to the venue of choice. Antarès is a modern indoor sports arena situated in Le Mans, France. Nestled within the Circuit de la Sarthe—renowned for hosting the legendary 24 Hours of Le Mans—the arena lies next to the first right-hand kink on the iconic Mulsanne Straight. Since its opening in 1995, Antarès has hosted numerous events and can accommodate up to 6,023 spectators for basketball games.
    
    Hopefully this event will build on the momentum and success of the French futsal scene in the past few years.
    `,
  instagram: "https://www.instagram.com/p/Cs9lz5bLQJQ/",
  instagramCaption:"Photos courtesy of the AFC Kairat instagram account"
 };